<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Großflächen · PV &amp; BESS</p>

      <h2 class="presentation-page__title">End-to-End-Zugang zu Großflächenprojekten</h2>

      <p class="presentation-page__text">
        Von der Flächensicherung bis zum 20-Jahre-Betrieb — alles aus einer Hand.
      </p>

      <div class="presentation-page__highlights">
        <article
          v-for="item in items"
          :key="item.heading"
          class="presentation-page__highlight-card"
        >
          <div class="presentation-page__highlight-icon" aria-hidden="true">
            <i :class="['fa', item.icon]"></i>
          </div>
          <h3 class="presentation-page__highlight-heading">{{ item.heading }}</h3>
          <p class="presentation-page__highlight-text">{{ item.text }}</p>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage25',

  components: { PrintPageLandscape, PresentationPage },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      items: [
        {
          icon: 'fa-sitemap',
          heading: 'End-to-End-Projektentwicklung',
          text: 'Von Flächensicherung und Projektentwicklung bis zur Baureife.',
        },
        {
          icon: 'fa-check-circle',
          heading: 'Risikominimierung durch Erfahrung',
          text:
            'Hohe Projektsicherheit dank regulatorischer, technischer und netzseitiger Expertise.',
        },
        {
          icon: 'fa-sun-o',
          heading: 'Technische Exzellenz',
          text:
            'Tiefes Know-how in PV, Grün- und Graustrom-BESS sowie MS- und HS-Umspannwerken inkl. Netzanschluss.',
        },
        {
          icon: 'fa-cogs',
          heading: 'Realisierungs- & Baukompetenz',
          text:
            'Durchführung, Steuerung und Überwachung des Anlagenbaus mit Fokus auf Qualität, Termine, Kosten.',
        },
        {
          icon: 'fa-flash',
          heading: 'Integrierte PV- & Speicherstrategie',
          text:
            'BESS als aktiver Werttreiber zur Flexibilisierung, Netzstabilisierung und Erlösmaximierung.',
        },
        {
          icon: 'fa-bolt',
          heading: 'Performance-orientierter Betrieb',
          text:
            'Professionelles Anlagenmanagement und datenbasiertes Monitoring über den gesamten Lebenszyklus.',
        },
      ],
    };
  },
};
</script>
